import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { TextField } from '@material-ui/core';

const styles = () => ({
  TextField: {
    maxWidth: 536,
    height: 'auto',
  },
});

const AboutFormLawyer = props => {
  const {
    classes,
    additionalInfo,
    setAdditionalInfo,
  } = props;

  const handleChange = e => {
    setAdditionalInfo(e.target.value)
  }

  return (
    <div>
      <div className="contentInput">
        <TextField
          label="Información adicional"
          id="additionalInfo"
          type="text"
          variant="outlined"
          rows='4'
          multiline={true}
          onChange={handleChange}
          value={additionalInfo}
          classes={{ root: classes.TextField }}
          fullWidth
          inputProps={{maxLength :320}}
        />
      </div>
    </div>
  );
};

const AboutFormLawyerCompose = compose(
  withStyles(styles),
)(AboutFormLawyer);

const mapStateToProps = state => ({
  valuesToEdit: state.proposalsReducer.selectedProposal,
});

export default connect(mapStateToProps)(AboutFormLawyerCompose);
